import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { HOME, NavigateToHome, getUserProfil, isLoggedIn } from "../../../Utils/Utils";
import BG from "../../../assets/images/bg.jpg";
import LOGO from "../../../assets/images/mtn.png";
import { LoginForm } from "../../../components/Auth/LoginForm";

export const Login = () => {
  const navigate = useNavigate();
  const user = getUserProfil();

  useEffect(() => {
    if (isLoggedIn()) {
      navigate(NavigateToHome())
    } else {
      navigate(HOME + '/login')
    }
  }, [user, navigate])

  return (

    <div
      class="font-mtn bg-white container relative  min-h-screen flex-col items-center justify-center md:grid lg:max-w-none lg:grid-cols-2 lg:px-0 "
    >
      <div className="hidden h-screen flex-col lg:flex">
        <img src={BG} className="h-screen w-full" alt="" />
      </div>
      <div
        class="p-8 mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[550px]"
      >
        <div className="flex gap-x-2 ">
          <img alt="" src={LOGO} className="w-9 rounded-2xl" />
          <p className="my-auto font-bold text-xl">MTN Fibre</p>
        </div>
        <div class="flex flex-col space-y-2">
          <h1 class="text-2xl font-semibold tracking-tight">Connexion au CRM</h1>
          <p class="text-sm text-muted-foreground">
            Saisissez vos identifiants pour vous connecter.
          </p>
        </div>
        <div className="grid gap-6">
          <LoginForm />
        </div>

      </div>
    </div>

  );
};